import { useEffect } from "react"
import PropTypes from "prop-types"
import { useNavigate } from 'react-router-dom'

import { signOut } from "@api/authenticate"


const IndexRedirect = ({ isBackstage }) => {
  const navigate = useNavigate()
  const path = isBackstage ? "/backstage" : "/"

  useEffect(() => {
    signOut()
      .then(() => navigate(path))
  }, [])

  return null
}

IndexRedirect.propTypes = {
  isBackstage: PropTypes.bool.isRequired,
}

export default IndexRedirect
